module.exports = __webpack_public_path__ + "img/160.c19f2c47.jpg";